import { render } from "./DecoyDeploy.vue?vue&type=template&id=22773d66&scoped=true"
import script from "./DecoyDeploy.vue?vue&type=script&lang=js"
export * from "./DecoyDeploy.vue?vue&type=script&lang=js"

import "./DecoyDeploy.vue?vue&type=style&index=0&id=22773d66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22773d66"]])

export default __exports__